<template>
  <div>
    <div class="questionnaire">
      <h3>{{ details.questionnaire_name }}</h3>
      <h6 v-html="details.survey_desc" style="line-height:35px; font-weight: 600;"></h6>
      <div class="user">
        <span>用户id：{{ details.user_id }}</span>
        <span>用户名：{{ details.login_name }}</span>
        <span>客户名：{{ details.user_name }}</span>
        <span class="time">提交时间：{{ details.create_time }}</span>
      </div>
      <div class="questionnaire-box">
        <div class="list" v-for="(item, index) in details.detail" :key="item.id" :id="'id' + index">
          <div class="items">
            <div class="title" v-html="item.title"></div>
            <div class="type">
              <span v-if="item.type == 0">（单选题）</span>
              <span v-else-if="item.type == 1">（多选题）</span>
              <span v-else-if="item.type == 2">（问答题）</span>
            </div>
            <div class="answer">
              <span v-for="(items, indexs) in item.answer" :key="indexs">
                {{ items }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {},
      isShow: false,
    };
  },
  created() {
    this.particularsDetail();
  },
  methods: {
    particularsDetail() {
      let datas = {
        id: this.$route.query.id,
        user_id: this.$route.query.user_id,
      };
      this.$api.clienteleApi.particularsDetail(datas).then((res) => {
        console.log(res.data);
        this.details = res.data;
        this.details.survey_desc = this.details.survey_desc.replace(
          /\n/g,
          "<br/>"
        );
        this.details.detail.forEach((item, index) => {
          item.title = index + 1 + "、" + item.title.replace(/\n/g, "<br/>");
          item.flag = true;
        });
      });
    },
    questionnaire_list_get() {
      this.$api.questionnaire_list_get(this.datas).then((res) => {
        let datas = res.data[0];
        this.details.detail.forEach((item) => {
          datas.detail.forEach((items) => {
            if (item.id == items.id) {
              item.answer = items.answer;
            }
          });
        });
        this.isShow = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.questionnaire {
  margin: 30px auto;
  width: 1200px;
  padding: 30px 40px;
  font-size: 16px;

  h3 {
    text-align: center;
    font-size: 25px;
    font-weight: 700;
  }

  h6 {
    // text-align: center;
    margin: 30px 0;
  }

  .questionnaire-box {
    padding-bottom: 30px;

    .list {
      margin-bottom: 30px;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 40px;
      border-radius: 8px;

      .title {
        font-size: 20px;
        text-align: left;
      }

      .type {
        margin: 20px;
        color: #027db4;
      }

      .answer {
        span {
          margin-right: 50px;
        }
      }
    }

    .btn {
      text-align: center;
    }

    /deep/.el-input__inner {
      width: 160px;
      margin-bottom: 20px;
    }
  }
}

.user {
  margin-bottom: 20px;

  span {
    margin-right: 20px;
  }

  .time {
    float: right;
  }
}
</style>
